import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Detalhes ")
const _hoisted_2 = {
  key: 0,
  class: "w-full grid place-content-center"
}
const _hoisted_3 = {
  key: 0,
  class: "w-full grid place-content-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlbumsOutline = _resolveComponent("AlbumsOutline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_n_data_table = _resolveComponent("n-data-table")!
  const _component_n_collapse_item = _resolveComponent("n-collapse-item")!
  const _component_n_collapse = _resolveComponent("n-collapse")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_n_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal = true)),
      type: "info",
      size: "small"
    }, {
      icon: _withCtx(() => [
        _createVNode(_component_n_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_AlbumsOutline)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_n_modal, {
      show: _ctx.showModal,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showModal) = $event)),
      "mask-closable": false,
      class: "w-full md:w-1/2",
      preset: "card",
      title: `Informações do arquivo ${_ctx.file.titulo}`
    }, {
      default: _withCtx(() => [
        _createVNode(_component_n_collapse, {
          "arrow-placement": "right",
          onItemHeaderClick: _ctx.collapseSelect
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_collapse_item, {
              title: "Documentos",
              name: "1"
            }, {
              default: _withCtx(() => [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_n_spin, { size: "small" })
                    ]))
                  : (_openBlock(), _createBlock(_component_n_data_table, {
                      key: 1,
                      columns: _ctx.columnsDocuments,
                      data: _ctx.documents,
                      pagination: _ctx.pagination,
                      bordered: false,
                      "max-height": 250
                    }, null, 8, ["columns", "data", "pagination"]))
              ]),
              _: 1
            }),
            _createVNode(_component_n_collapse_item, {
              title: "Histórico",
              name: "2"
            }, {
              default: _withCtx(() => [
                (_ctx.isLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_n_spin, { size: "small" })
                    ]))
                  : (_openBlock(), _createBlock(_component_n_data_table, {
                      key: 1,
                      columns: _ctx.columns,
                      data: _ctx.historics,
                      pagination: _ctx.pagination,
                      bordered: false,
                      "max-height": 250
                    }, null, 8, ["columns", "data", "pagination"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onItemHeaderClick"])
      ]),
      _: 1
    }, 8, ["show", "title"])
  ], 64))
}